(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/regenerator', 'babel-runtime/helpers/asyncToGenerator', './client'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('./client'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.client);
    global.token = mod.exports;
  }
})(this, function (exports, _regenerator, _asyncToGenerator2, _client) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getToken = undefined;
  var _regenerator2 = _interopRequireDefault(_regenerator);
  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
  var _client2 = _interopRequireDefault(_client);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var getToken = function () {
    var _ref = (0, _asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var accessToken, skippedErrors;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _client2.default.getTokenSilently();
            case 3:
              accessToken = _context.sent;
              return _context.abrupt('return', accessToken);
            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);
              skippedErrors = ['login_required', 'mfa_required', 'missing_refresh_token', 'invalid_grant'];
              if (skippedErrors.includes(_context.t0.error)) {
                _context.next = 13;
                break;
              }
              console.error(_context.t0);
              throw _context.t0;
            case 13:
              return _context.abrupt('return', null);
            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 7]]);
    }));
    return function getToken() {
      return _ref.apply(this, arguments);
    };
  }();
  exports.getToken = getToken;
});